const f = ["#fdefd9", "#ffc970", "#bf3b40", "#301145"], E = [
  "#ffdf9f",
  "#ffb340",
  "#e04d2f",
  "#9e2951",
  "#301145"
], _ = [
  "#fdefd9",
  "#ffdf9f",
  "#ffb340",
  "#e04d2f",
  "#9e2951",
  "#301145"
];
export {
  f as DEMOGRAPHICS_YELLOW_RED_PURPLE_4,
  E as DEMOGRAPHICS_YELLOW_RED_PURPLE_5,
  _ as DEMOGRAPHICS_YELLOW_RED_PURPLE_6
};
//# sourceMappingURL=index.es5691.js.map
